import { FC } from "react";
import classNames from "classnames";
import "./styles.sass";

type LoyaltyRoundButtonProps = {
  label: string;
  active?: boolean;
  handleClick?: () => void;
  className?: string;
};

const LoyaltyRoundButton: FC<LoyaltyRoundButtonProps> = (props) => {
  const { label, active, handleClick, className } = props;

  const classNameBtn = classNames(
    "LoyaltyRoundButton",
    active && "LoyaltyRoundButton_active",
    className,
  );

  return (
    <button type="button" onClick={handleClick} className={classNameBtn}>
      {label}
    </button>
  );
};

export default LoyaltyRoundButton;
